import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getTableauView } from "@/api/tableau";
import { getUserDealerGroup, getCurrUserMapDealerCodes } from "@/api/td_dealer";
import { findRmParam } from "@/api/rm_param";
import { updateRmUserFavorite, getRmUserFavoriteList, getRmUserFavoriteAndRmMenuList } from "@/api/rm_user_favorite"; //  此处请自行替换地址
import { getCookie } from "@/utils/cookie";
import { createRmReportBrowse, getRmReportBrowseInfoByUserId } from "@/api/rm_report_browse"; //

import { formatTimeToStr } from "@/utils/data";
import infoList from "@/components/mixins/infoList";
import { mapGetters } from "vuex";
export default {
  name: "dashboardIndex",
  mixins: [infoList],
  data: function data() {
    return {
      //listApi: getRmMenuList,
      favoriteList: [],
      activeNames: ['1', '2'],
      favoriteDialog: false,
      dialogTitle: "",
      visible: false,
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      userId: parseInt(getCookie("userId")),
      nickName: getCookie("nickName"),
      favoriteInfo: {
        ID: null,
        name: null,
        reportcode: null,
        rmMenuId: null,
        rmToolId: null,
        userId: null,
        params: null,
        URL: null,
        isdelete: null,
        createby: null,
        updateby: null,
        remark: null,
        shareby: null,
        shareto: null
      },
      statusOptions: [{
        value: '1',
        label: this.$t('common.enable')
      }, {
        value: '0',
        label: this.$t('common.disable')
      }],
      showfrontOptions: [{
        value: '1',
        label: this.$t("common.enable")
      }, {
        value: '0',
        label: this.$t('common.disable')
      }],
      reportTypeOptions: [{
        value: '1',
        label: this.$t('report_card.thirdparty')
      }, {
        value: '2',
        label: this.$t('report_card.self_design')
      }],
      tableauUrl: ""
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo'])),
  methods: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? this.$t('common.yes') : this.$t('common.no');
      } else {
        return "";
      }
    },
    statusFilter: function statusFilter(value) {
      var target = this.statusOptions.filter(function (item) {
        return item.value === value;
      })[0];
      // return target && `${target.label}(${target.value})`
      return target && "".concat(target.label);
    },
    reportTypeFilter: function reportTypeFilter(value) {
      var target = this.reportTypeOptions.filter(function (item) {
        return item.value === value;
      })[0];
      return target && "".concat(target.label);
    },
    tableauView: function () {
      var _tableauView = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(card) {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getTableauView({
                wgserver: card.rmtool.reportToolAuthUrl,
                username: card.rmtool.reportToolKey,
                view: card.reportUrl
              });
            case 1:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function tableauView(_x) {
        return _tableauView.apply(this, arguments);
      }
      return tableauView;
    }(),
    userDealerGroup: function () {
      var _userDealerGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getUserDealerGroup({
                userId: parseInt(this.userId)
              });
            case 1:
              res = _context2.sent;
              return _context2.abrupt("return", res);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function userDealerGroup() {
        return _userDealerGroup.apply(this, arguments);
      }
      return userDealerGroup;
    }(),
    // 查询用户的数据权限(能看哪些门店的数据)
    // 组装的时候区分 Tableau 和 SSRC
    // Tableau的参数形式为 &DP_Dealer=7000520,7000001
    // SSRC的参数形式为 &DP_Dealer=7000520&DP_Dealer=7000001
    buildDealerCodes: function () {
      var _buildDealerCodes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(reportToolName) {
        var result, res, codes, firstData;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              result = '&DP_Dealer=longniandaji';
              _context3.next = 1;
              return getCurrUserMapDealerCodes();
            case 1:
              res = _context3.sent;
              if (!(res.code != 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", result);
            case 2:
              codes = res.data;
              if (!(!codes || codes.length == 0)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", result);
            case 3:
              // 返回查看全部dealer时的DP_Dealer参数组装
              firstData = codes[0];
              if (!(firstData == 'ALL')) {
                _context3.next = 4;
                break;
              }
              if (reportToolName == 'Tableau') {
                result = '&DP_Dealer=';
              } else {
                result = '&DP_Dealer=ALL';
              }
              return _context3.abrupt("return", result);
            case 4:
              // DP_Dealer参数组装
              result = '';
              codes.forEach(function (code) {
                result = result + code + ',';
              });
              result = result.substring(0, result.length - 1);
              result = '&DP_Dealer=' + encodeURIComponent(result);
              return _context3.abrupt("return", result);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function buildDealerCodes(_x2) {
        return _buildDealerCodes.apply(this, arguments);
      }
      return buildDealerCodes;
    }(),
    OpenCard: function () {
      var _OpenCard = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(card) {
        var url, filterUrl, reportInfoRes, reportRole;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.reportBrowse(card);
            case 1:
              url = '', filterUrl = "";
              if (!(card.reportAttribute > 0)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 2;
              return findRmParam({
                ID: card.reportAttribute
              });
            case 2:
              reportInfoRes = _context4.sent;
              if (!(reportInfoRes.code == 0)) {
                _context4.next = 4;
                break;
              }
              reportRole = reportInfoRes.data.rermParam.paramName.toLowerCase();
              if (!reportRole) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return this.buildDealerCodes(card.rmtool.reportToolName);
            case 3:
              filterUrl = _context4.sent;
            case 4:
              // end---根据报表配置的参数设置url的参数，报表参数 Report parameters，现在只需要判断是否要传参数，没有的话后面不拼参数，有的话拼上DealerCode

              if (card.reportType == '1') {
                //h5页面
                url = card.reportUrl;
              } else {
                if (card.rmtool.reportToolName == "Tableau") {
                  /** 新打开TAB的时候会请求两次tableau，此处需要改造 */
                  url = "tableau?wgserver=" + card.rmtool.reportToolAuthUrl + "&remoteAddr=" + card.rmtool.reportToolUrl + "&username=" + card.rmtool.reportToolKey + "&view=" + card.reportUrl + "&tabType=" + card.tabType;
                } else {
                  // ssrs
                  url = card.rmtool.reportToolUrl + "?Path=" + card.reportUrl + "";
                }
              }
              url = window.btoa(url + filterUrl);
              _context4.next = 5;
              return this.toDetailInfo(url, card.reportNameEn);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function OpenCard(_x3) {
        return _OpenCard.apply(this, arguments);
      }
      return OpenCard;
    }(),
    reportBrowse: function () {
      var _reportBrowse = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(card) {
        var reportId, brows;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              reportId = card.ID;
              brows = {
                userId: this.userId,
                reportId: reportId,
                nickName: this.nickName,
                OperationDesc: card.operationDesc,
                operationObj: card.operationObj
              };
              _context5.next = 1;
              return createRmReportBrowse(brows);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function reportBrowse(_x4) {
        return _reportBrowse.apply(this, arguments);
      }
      return reportBrowse;
    }(),
    OpenTableau: function () {
      var _OpenTableau = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(card) {
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // 操作记录需要的参数
              card.operationDesc = this.$t('reporting_log.open_card') + ' (' + this.$t('reporting_log.page_over_view') + ')';
              card.operationObj = card.reportNameZh;
              this.OpenCard(card);
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function OpenTableau(_x5) {
        return _OpenTableau.apply(this, arguments);
      }
      return OpenTableau;
    }(),
    OpenFavoriteTableau: function () {
      var _OpenFavoriteTableau = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(card) {
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              card = card.rmMenu;
              // 操作记录需要的参数
              card.operationDesc = this.$t('reporting_log.open_card') + ' (' + this.$t('reporting_log.page_over_view') + ')';
              card.operationObj = card.reportNameZh;
              _context7.next = 1;
              return this.OpenCard(card);
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function OpenFavoriteTableau(_x6) {
        return _OpenFavoriteTableau.apply(this, arguments);
      }
      return OpenFavoriteTableau;
    }(),
    toDetailInfo: function () {
      var _toDetailInfo = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(body, cardName) {
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return this.$router.push({
                name: "reportcardDetail",
                params: {
                  body: body,
                  report: cardName
                }
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function toDetailInfo(_x7, _x8) {
        return _toDetailInfo.apply(this, arguments);
      }
      return toDetailInfo;
    }(),
    getBrowserLst: function () {
      var _getBrowserLst = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return getRmReportBrowseInfoByUserId({
                userId: this.userId
              });
            case 1:
              res = _context9.sent;
              if (res.code == 0) {
                this.tableData = res.data.rermReportBrowse;
              }
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getBrowserLst() {
        return _getBrowserLst.apply(this, arguments);
      }
      return getBrowserLst;
    }(),
    getFavoriteLst: function () {
      var _getFavoriteLst = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return getRmUserFavoriteAndRmMenuList({
                userId: this.userId
              });
            case 1:
              res = _context0.sent;
              if (res.code == 0 && res.data.total > 0) {
                this.favoriteList = res.data.rmUserFavorites;
              }
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function getFavoriteLst() {
        return _getFavoriteLst.apply(this, arguments);
      }
      return getFavoriteLst;
    }(),
    favorite: function () {
      var _favorite = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(card, type) {
        var favourite, menuId, name, opt_desc, res;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              // recent card 传的是 rmMenu
              // favourite card 传 card, type传1
              favourite = 0;
              menuId = "";
              name = "";
              if (type === 1) {
                favourite = card.isFavourite;
                menuId = "" + card.rmMenuId;
                name = card.rmMenu.reportNameZh;
              } else {
                favourite = card.isFavorite;
                menuId = "" + card.ID;
                name = card.reportNameZh;
              }
              this.favoriteInfo.isFavourite = favourite == 1 ? 0 : 1;
              this.favoriteInfo.name = name;
              this.favoriteInfo.userId = "" + this.userId;
              this.favoriteInfo.rmMenuId = menuId;

              // 添加操作日志
              opt_desc = this.$t('reporting_log.favorite_card');
              if (this.favoriteInfo.isFavourite === 0) {
                opt_desc = this.$t('reporting_log.cancel_favorite_card');
              }
              this.reportBrowse({
                ID: parseInt(this.favoriteInfo.rmMenuId),
                operationDesc: opt_desc,
                operationObj: this.favoriteInfo.name
              });

              //处理 收藏/取消收藏
              if (card.rmtool) {
                this.favoriteInfo.rmToolId = "" + card.rmtool.ID;
              } else {
                this.favoriteInfo.rmToolId = "" + card.rmMenu.rmtool.ID;
              }
              this.favoriteInfo.URL = card.reportUrl;
              if (!(card.isFavorite === 0)) {
                _context1.next = 1;
                break;
              }
              this.favoriteDialog = true;
              _context1.next = 5;
              break;
            case 1:
              _context1.next = 2;
              return getRmUserFavoriteList({
                rmMenuId: menuId,
                userId: "" + this.userId,
                PageSize: 1
              });
            case 2:
              res = _context1.sent;
              if (res.code == 0) {
                //this.favoriteInfo.updatedAt = new Date();
                this.favoriteInfo.updateby = this.userId;
                this.favoriteInfo.ID = res.data.ID;
              }
              this.$message({
                type: "info",
                message: "Cancel Favourite Success"
              });
              _context1.next = 3;
              return updateRmUserFavorite(this.favoriteInfo);
            case 3:
              _context1.next = 4;
              return this.getBrowserLst();
            case 4:
              _context1.next = 5;
              return this.getFavoriteLst();
            case 5:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function favorite(_x9, _x0) {
        return _favorite.apply(this, arguments);
      }
      return favorite;
    }(),
    closeAddFavoritDialog: function closeAddFavoritDialog() {
      this.favoriteDialog = false;
      this.favoriteInfo = {
        ID: null,
        name: null,
        reportcode: null,
        rmMenuId: null,
        userId: null,
        rmToolId: null,
        params: null,
        URL: null,
        isdelete: null,
        createby: null,
        updateby: null,
        remark: null,
        shareby: null,
        shareto: null
      };
    },
    enterAddFavoritDialog: function () {
      var _enterAddFavoritDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.favoriteInfo.userId = "" + this.userId;
              _context10.next = 1;
              return updateRmUserFavorite(this.favoriteInfo);
            case 1:
              res = _context10.sent;
              if (!(res.code == 0)) {
                _context10.next = 3;
                break;
              }
              this.closeAddFavoritDialog();
              this.$message({
                type: "success",
                message: this.$t('common.success')
              });
              _context10.next = 2;
              return this.getBrowserLst();
            case 2:
              _context10.next = 3;
              return this.getFavoriteLst();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function enterAddFavoritDialog() {
        return _enterAddFavoritDialog.apply(this, arguments);
      }
      return enterAddFavoritDialog;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            localStorage.clear();
            _context11.next = 1;
            return this.getBrowserLst();
          case 1:
            _context11.next = 2;
            return this.getFavoriteLst();
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};